import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Drawer } from '@mui/material';
// mock
// hooks
import useResponsive from '../../../hooks/useResponsive';
// components
import Logo from '../../../components/logo';
import Scrollbar from '../../../components/scrollbar';
import NavSection from '../../../components/nav-section';
//
import { navConfig, navConfigSudo, navConfigEdifier, siteLeaderNav, principalNavConfig } from './config';

import { mockUserData } from '../../../_mock/index';

// ----------------------------------------------------------------------

const NAV_WIDTH = 320;

export default function Nav({ openNav, onCloseNav,showNav }) {
  const userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : mockUserData;

  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
        bgcolor: 'background.paper',
      }}
    >
      <Box sx={{ px: 2.5, py: 3, display: 'inline-flex' }}>
        <Logo />
      </Box>
      {/* Profile Section  */}
      {/* <Box sx={{ mb: 5, mx: 2.5 }}>
        <Link underline="none">
          <StyledAccount>
            <Avatar src={account.photoURL} alt="photoURL" />

            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                {account.displayName}
              </Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {account.role}
              </Typography>
            </Box>
          </StyledAccount>
        </Link>
      </Box> */}

      {/* Profile Section  */}

      <NavSection
        role={userDetails.role.toLowerCase()}
        data={
          userDetails.role.toLowerCase() === 'admin'
            ? navConfigSudo
            : userDetails.role.toLowerCase() === 'coach'
            ? navConfigEdifier
            : userDetails.role.toLowerCase() === 'site-leader'
            ? siteLeaderNav
            : userDetails.role.toLowerCase() === 'principal'
            ? principalNavConfig
            : navConfig
        }
        sx={{ pl: '6px' }}
      />

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg:!showNav && NAV_WIDTH },
      }}
    >
      {(isDesktop && !showNav) ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width:!showNav && NAV_WIDTH,
              bgcolor: 'background.default',
              border: 'none',
              borderRadius: 0,
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: NAV_WIDTH, borderRadius: 0 },
            border: 'none',
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
